import React, { lazy } from 'react';
import { Gift, CheckSquare, MessageSquare, Brain, Zap, Video, Leaf, ChefHat, Calculator } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
export function BonusSection() {
  const bonuses = [{
    id: 1,
    title: 'Mi Primer Condimento en 24h (Checklist + Video)',
    value: 46000,
    icon: CheckSquare,
    color: 'from-emerald-400 to-emerald-600',
    image: 'https://cdn.magicpatterns.com/uploads/jUKpao9UeBaKhrQFr4cC7B/bono_1.jpg'
  }, {
    id: 2,
    title: 'Kit Venta Lista: Etiquetas Editables + Scripts de WhatsApp',
    value: 65000,
    icon: MessageSquare,
    color: 'from-teal-400 to-teal-600',
    image: 'https://cdn.magicpatterns.com/uploads/erk17uCuc5m2AtBzA99ngf/bono_2.jpg'
  }, {
    id: 3,
    title: 'Guía: Vender Sin Vergüenza (Mentalidad de Vendedora)',
    value: 36000,
    icon: Brain,
    color: 'from-emerald-500 to-emerald-700',
    image: 'https://cdn.magicpatterns.com/uploads/hANzAvE2tVKSpsbxXC71xS/bono_3.jpg'
  }, {
    id: 4,
    title: 'Condimentos Express: 15 Recetas de 20 Minutos',
    value: 46000,
    icon: Zap,
    color: 'from-teal-500 to-teal-700',
    image: 'https://cdn.magicpatterns.com/uploads/7Szf34UDJXgGxp8BMuYr2a/bono_4.jpg'
  }, {
    id: 5,
    title: 'Masterclass en Video: De Condimentos a Negocio',
    value: 95000,
    icon: Video,
    color: 'from-emerald-400 to-emerald-600',
    image: 'https://cdn.magicpatterns.com/uploads/rGsN2PetmxYpaMQEgDYGv6/bono_5.jpg'
  }, {
    id: 6,
    title: 'Guía de Condimentos Italianos Artesanales',
    value: 56000,
    icon: Leaf,
    color: 'from-teal-400 to-teal-600',
    image: 'https://cdn.magicpatterns.com/uploads/htDwb5SKno6UpE5j37F1WV/bono_6.jpg'
  }, {
    id: 7,
    title: 'Salsas Gourmet para Vender: Recetas de Alto Margen',
    value: 65000,
    icon: ChefHat,
    color: 'from-emerald-500 to-emerald-700',
    image: 'https://cdn.magicpatterns.com/uploads/fqjC2hPnM5BZ7bESvLJsAC/bono_7.jpg'
  }, {
    id: 8,
    title: 'Calculadora Anti-Inflación: Fijá Tus Precios Automáticamente',
    value: 46000,
    icon: Calculator,
    color: 'from-teal-500 to-teal-700',
    image: 'https://cdn.magicpatterns.com/uploads/gp9VeVKVd9kcBLzXXkACVa/bono_8.jpg'
  }];
  return <section className="py-8 md:py-20 px-4 bg-spice-900 text-white relative overflow-hidden" data-id="element-34">
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-accent-300 via-accent-500 to-accent-300" data-id="element-35"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-36">
        <div className="text-center mb-6 md:mb-12" data-id="element-37">
          <Gift className="w-10 h-10 md:w-14 md:h-14 text-accent-400 mx-auto mb-3 md:mb-5" data-id="element-38" />
          <h2 className="text-3xl md:text-5xl font-bold mb-4 text-white" data-id="element-39">
            Reclama Estos 8 Bonos Exclusivos Si Ordenas HOY
          </h2>
          <p className="text-lg text-spice-200" data-id="element-40">
            Si entrás hoy, te doy 8 bonos especiales por tiempo limitado…
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-4 mb-6 md:mb-12" data-id="element-41">
          {bonuses.map(bonus => {
          const Icon = bonus.icon;
          return <div key={bonus.id} className="bg-spice-800 border border-accent-500/30 rounded-xl p-3 md:p-4 flex flex-col items-center text-center gap-2 md:gap-3 transition-transform hover:-translate-y-1 hover:border-accent-400" data-id="element-42">
                {bonus.image ? <div className="w-full aspect-[4/3] md:aspect-square rounded-lg overflow-hidden shadow-md" data-id="element-43">
                    <img src={bonus.image} alt={bonus.title} loading="lazy" width="200" height="200" className="w-full h-full object-cover" data-id="element-44" />
                  </div> : <div className={`bg-gradient-to-br ${bonus.color} w-full h-24 rounded-lg flex items-center justify-center shadow-md`} data-id="element-45">
                    <Icon className="w-10 h-10 text-white/90" data-id="element-46" />
                  </div>}
                <div data-id="element-47">
                  <h3 className="text-sm md:text-base font-bold text-spice-100 mb-2 leading-snug" data-id="element-48">
                    Bono #{bonus.id} — {bonus.title}
                  </h3>
                  <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-49">
                    <span className="text-spice-300 line-through text-xs" data-id="element-50">
                      <PriceDisplay amountArs={bonus.value} data-id="element-51" />
                    </span>
                    <span className="bg-accent-500/20 text-accent-300 px-2 py-0.5 rounded-full font-bold text-xs border border-accent-500/30" data-id="element-52">
                      GRATIS
                    </span>
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div className="bg-gradient-to-br from-accent-500 to-accent-600 rounded-2xl p-5 md:p-10 text-center border-2 border-accent-400 shadow-2xl" data-id="element-53">
          <p className="text-white/80 font-medium text-base mb-2" data-id="element-54">
            Valor Total de los Bonos:
          </p>
          <p className="text-4xl md:text-5xl font-black text-white mb-3 line-through decoration-urgency-500 decoration-4" data-id="element-55">
            +<PriceDisplay amountArs={455000} data-id="element-56" />
          </p>
          <p className="text-xl md:text-2xl font-bold text-white animate-pulse" data-id="element-57">
            ¡TODOS GRATIS SI ORDENÁS HOY!
          </p>
        </div>
      </div>
    </section>;
}